import Validation from '../../../Validation/index.js';
import { InputStates } from '../../FieldControlled/common.js';

function getValidationState(state) {
    const { valid, messages: alarms, warnings } = state;
    let validation = { state: undefined, stateMessage: undefined };
    if (!valid && alarms && alarms.length > 0) {
        validation = { state: InputStates.alarm, stateMessage: alarms.join(', ') };
    }
    else if (valid && warnings && warnings.length > 0) {
        validation = { state: InputStates.warning, stateMessage: warnings.join(', ') };
    }
    else if (!valid) {
        validation = { state: InputStates.loading };
    }
    return validation;
}
// eslint-disable-next-line import/prefer-default-export
function getAsyncInputStateByValidations(validations, value) {
    const result = Validation.validateAsyncAll(validations, value);
    if (result instanceof Promise) {
        return result.then((state) => getValidationState(state));
    }
    return getValidationState(result);
}

export { getAsyncInputStateByValidations };
